import { render, staticRenderFns } from "./index.vue?vue&type=template&id=385763a9&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385763a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('385763a9')) {
      api.createRecord('385763a9', component.options)
    } else {
      api.reload('385763a9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=385763a9&scoped=true", function () {
      api.rerender('385763a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/sort/index.vue"
export default component.exports